import $ from 'jquery';
import NProgress from 'nprogress';
import 'velocity-animate';

import config from './globals/config';
import setTrailerDrawerInfo from './set-trailer-drawer-info';
import setTrailerDrawerTopNav from './set-trailer-drawer-top-nav';

export default function (
  trailerDrawerBG,
  trailerDrawerTitle,
  trailerDrawerInfoTitle,
  trailerDrawerDesktop,
  leftTrailer,
  rightTrailer,
  trailerDrawerInfoSeeMore,
  trailerDrawerInfoText
) {
  let currentTrailerNum = config.currentTrailerNum;

  function loadNext () {

    setTrailerDrawerInfo(
      trailerDrawerBG,
      trailerDrawerTitle,
      trailerDrawerInfoTitle,
      trailerDrawerDesktop,
      trailerDrawerInfoSeeMore,
      trailerDrawerInfoText
    );

    NProgress.done();

    trailerDrawerBG.velocity({ translateX: '35%' }, {
      duration: config.intervalTiming,
      easing  : 'linear',
      complete: function () {
        trailerDrawerTitle.velocity('stop').velocity({ opacity: 0 }, { duration: 300 });

        $(this).velocity('stop').velocity({ opacity: 0 }, {
          duration: 600,
          complete: function () {
            $(this).velocity({ translateX: 0 }, { duration: 0 });

            if (config.trailerDrawerIsRotating) {
              loadNext();
            }
          },
        });
      },
    });

    setTrailerDrawerTopNav(leftTrailer, rightTrailer, currentTrailerNum);

    currentTrailerNum++;
    if (currentTrailerNum > config.max) {
      currentTrailerNum = 0;
    }

    config.currentTrailerNum = currentTrailerNum;
  }

  loadNext();
}
